var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardEvil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0933 23.8537C56.6733 15.8837 64.4034 10.7037 72.3734 12.2837L96.4134 17.0437C104.383 18.6237 109.563 26.3536 107.983 34.3236L100.853 70.3937C99.2734 78.3637 91.5434 83.5436 83.5734 81.9636L59.5333 77.2036C51.5633 75.6236 46.3833 67.8936 47.9633 59.9236L55.0933 23.8537Z",
    fill: "#94D133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7044 48.9532C66.6044 49.5232 69.4144 47.6432 69.9844 44.7432C70.5544 41.8432 68.6744 39.0332 65.7744 38.4632C62.8744 37.8932 60.0644 39.7731 59.4944 42.6731C58.9244 45.5731 60.8044 48.3832 63.7044 48.9532Z",
    fill: "#1278A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0443 54.1533C92.9443 54.7233 95.7543 52.8434 96.3243 49.9434C96.8943 47.0434 95.0143 44.2334 92.1143 43.6634C89.2143 43.0934 86.4043 44.9734 85.8343 47.8734C85.2643 50.7734 87.1443 53.5833 90.0443 54.1533Z",
    fill: "#1278A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0139 30.6032C45.1439 29.9432 45.7939 29.5032 46.4539 29.6432L57.0939 31.7432L53.8839 47.9732L48.0539 46.8231C44.7339 46.1631 42.5739 42.9432 43.2339 39.6232L45.0139 30.6032Z",
    fill: "#94D133"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.743 44.3938C114.873 43.7338 114.443 43.0837 113.783 42.9537L104.583 41.1338L101.373 57.3638L105.763 58.2338C109.083 58.8938 112.303 56.7337 112.963 53.4137L114.743 44.3938Z",
    fill: "#94D133"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3047 61.9336L87.7547 67.1636",
    stroke: "#1278A0",
    strokeWidth: 4.9,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2344 28.1533L72.7844 35.4634",
    stroke: "#42A50E",
    strokeWidth: 7.35,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9029 34.8135L87.2129 38.3235",
    stroke: "#42A50E",
    strokeWidth: 7.35,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2244 58.5639C63.6144 56.5739 65.5544 55.2739 67.5444 55.6739C69.5344 56.0739 70.8344 58.004 70.4344 59.994L70.1944 61.1939L62.9844 59.764L63.2244 58.5639Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0544 61.894C80.4444 59.904 82.3845 58.604 84.3745 59.004C86.3645 59.404 87.6645 61.3339 87.2645 63.3239L87.0244 64.5239L79.8145 63.0939L80.0544 61.894Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardEvil);
export default __webpack_public_path__ + "static/media/card_evil.f490b683a6c762a4d8ed1661d8c6d264.svg";
export { ForwardRef as ReactComponent };